import { useRouter } from "next/router";
import { FC, useEffect } from "react";

import { storeIsLeadFromSmajla } from "./helpers";

export const SmajlaService: FC<{}> = () => {
    const { asPath } = useRouter();

    useEffect(() => {
        const { smajla } = Object.fromEntries(
            new URLSearchParams(asPath.split("?")[1])
        );

        if (smajla) {
            storeIsLeadFromSmajla();
        }
    }, [asPath]);

    return null;
};
